var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2229 23.1242C16.2218 22.3742 16.3719 21.6313 16.6644 20.9385C16.9569 20.2457 17.3861 19.6166 17.9272 19.0875C18.4684 18.5584 19.1107 18.1398 19.8173 17.8557C20.5239 17.5717 21.2807 17.4278 22.0441 17.4325C25.2297 17.4557 27.7778 20.0572 27.7778 23.1957V23.7567C27.7778 26.5881 28.3807 28.2311 28.9117 29.1291C28.9689 29.225 28.9994 29.3341 29 29.4453C29.0006 29.5565 28.9713 29.6659 28.9152 29.7624C28.859 29.859 28.7779 29.9393 28.6801 29.9952C28.5823 30.0511 28.4712 30.0807 28.358 30.081H15.642C15.5288 30.0807 15.4177 30.0511 15.3198 29.9952C15.222 29.9392 15.1409 29.8589 15.0848 29.7624C15.0286 29.6658 14.9994 29.5564 15 29.4452C15.0006 29.334 15.0311 29.2249 15.0883 29.1289C15.6197 28.2309 16.2229 26.5879 16.2229 23.7567L16.2229 23.1242Z",
    stroke: "#242424",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15H24.5",
    stroke: "#242424",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30.0811V30.6648C19 31.2842 19.3161 31.8781 19.8787 32.316C20.4413 32.754 21.2044 33 22 33C22.7956 33 23.5587 32.754 24.1213 32.316C24.6839 31.8781 25 31.2842 25 30.6648V30.0811",
    stroke: "#242424",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/notifyIcon.a10dc27d3ba4aea6538f83785677aab4.svg";
export { ForwardRef as ReactComponent };